import axiosInstance from "../AxiosInstance";

const getBaseUrl = () => {
    const userData = JSON.parse(localStorage.getItem('userData') || 'null');
    const isAdmin = userData && userData.is_admin === 1;
    return isAdmin ? '/admin/banners' : '/banners';
};

export const getBanners = (props) => {
    const url = getBaseUrl();
    props.setIsLoading && props.setIsLoading(true);
    axiosInstance.get(url).then((response) => {
        props.setBanners(response.data.data);
        props.setIsLoading && props.setIsLoading(false);
    }).catch((error) => {
        console.log(error);
        props.setIsLoading && props.setIsLoading(false);
        if (error.response && error.response.status === 422) {
            props.setErrors && props.setErrors(error.response.data.message);
        } else {
            props.setErrors && props.setErrors(error.message);
        }
    });
};

export const createBanner = (props) => {
    const url = getBaseUrl();
    props.setIsLoading && props.setIsLoading(true);
    axiosInstance.post(url, props.formData, {
        headers: {'Content-Type': 'multipart/form-data'}
    }).then((response) => {
        props.setIsLoading && props.setIsLoading(false);
        props.setMessage && props.setMessage(response.data.message);
        props.setShow && props.setShow(false);
        props.setUpdate && props.setUpdate(!props.update);
    }).catch((error) => {
        console.log(error);
        props.setIsLoading && props.setIsLoading(false);
        if (error.response && error.response.status === 422) {
            props.setErrors && props.setErrors(error.response.data.message);
        } else {
            props.setErrors && props.setErrors(error.message);
        }
    });
};

export const updateBanner = (props) => {
    const url = `${getBaseUrl()}/${props.bannerId}`;
    props.setIsLoading && props.setIsLoading(true);
    props.formData.append('_method', 'PUT');
    axiosInstance.post(url, props.formData, {
        headers: {'Content-Type': 'multipart/form-data'}
    }).then((response) => {
        props.setIsLoading && props.setIsLoading(false);
        props.setMessage && props.setMessage(response.data.message);
        props.setShow && props.setShow(false);
        props.setUpdate && props.setUpdate(!props.update);
    }).catch((error) => {
        console.log(error);
        props.setIsLoading && props.setIsLoading(false);
        if (error.response && error.response.status === 422) {
            props.setErrors && props.setErrors(error.response.data.message);
        } else {
            props.setErrors && props.setErrors(error.message);
        }
    });
};

export const toggleBannerActive = (props) => {
    const url = `${getBaseUrl()}/${props.bannerId}`;
    const data = new FormData();
    data.append('_method', 'PUT');
    data.append('is_active', props.is_active ? 0 : 1);
    axiosInstance.post(url, data, {
        headers: {'Content-Type': 'multipart/form-data'}
    }).then((response) => {
        props.setUpdate && props.setUpdate(prev => !prev);
    }).catch((error) => {
        console.log(error);
        props.setErrors && props.setErrors(error.message);
    });
};

export const deleteBanner = (props) => {
    const url = `${getBaseUrl()}/${props.bannerId}`;
    props.setIsLoading && props.setIsLoading(true);
    axiosInstance.delete(url).then((response) => {
        props.setIsLoading && props.setIsLoading(false);
        props.setMessage && props.setMessage(response.data.message);
        props.setShowConfirm && props.setShowConfirm(false);
        props.setUpdate && props.setUpdate(!props.update);
    }).catch((error) => {
        console.log(error);
        props.setIsLoading && props.setIsLoading(false);
        if (error.response && error.response.status === 422) {
            props.setErrors && props.setErrors(error.response.data.message);
        } else {
            props.setErrors && props.setErrors(error.message);
        }
    });
};
